/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";

/*import url and gateway methods */
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";
import { getAllCategories } from "helper/CategoryHelper/CategoryHelper";
import { ecosystemSlug, reactSelectStyle } from "Config/Config";
import { useTranslation } from "react-i18next";

const SaveHiringProcessPopup = ({ processId, setProcessId, onModalClose }) => {
  const todayValue = new Date().toISOString().split("T")[0];

  const token = localStorage.getItem("token");
  const params = useParams();
  const { t } = useTranslation(); //for translation
  const [allSkills, setAllSkills] = useState([]);

  const [title, setTitle] = useState("");
  const [location, setLocation] = useState("");
  const [order, setOrder] = useState(1);
  const [startDate, setStartDate] = useState(todayValue);
  const [endDate, setEndDate] = useState(todayValue);

  //template for kpis block
  const kpisBlockTemplate = {
    skillValue: null,
    selectedSkill: null,
    point: "",
  };

  const [kpisBlock, setKpisBlock] = useState([]);

  /* hooks for validation */
  const [errors, setErrors] = useState({});

  const [isSaving, setIsSaving] = useState(false);

  // Custom styles for kpis select
  const customKpisSelectStyle = {
    control: (base, state) => ({
      ...base,
      borderColor: errors.kpis ? "#dc3545" : "#ced4da",
      "&:hover": {
        borderColor: errors.kpis ? "#dc3545" : "#ced4da",
      },
      borderRadius: "8px",
      padding: "3.5px",
      minHeight: "45px",
      boxShadow: "none",
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: "0.875rem",
      color: "#6c757d",
    }),
    input: (base) => ({
      ...base,
      fontSize: "0.875rem",
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: "0.875rem",
    }),
  };

  //function for get all category
  const getAllSkills = async () => {
    try {
      const parentSlug = "skills";
      const response = await getAllCategories(ecosystemSlug, parentSlug);

      setAllSkills(response);
    } catch (error) {
      console.log(error.message);
    }
  };

  //change form inputs values
  const kpisFormInputChangeHandler = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "title":
        setTitle(value);
        setErrors((prev) => ({ ...prev, title: "" }));
        break;
      case "location":
        setLocation(value);
        setErrors((prev) => ({ ...prev, location: "" }));
        break;
      case "order":
        setOrder(value);
        break;
      case "startdate":
        setStartDate(value);
        setErrors((prev) => ({ ...prev, dates: "" }));
        break;
      case "enddate":
        setEndDate(value);
        setErrors((prev) => ({ ...prev, dates: "" }));
        break;
      default:
        console.log("Input section not found");
        break;
    }
  };

  //add kpis block
  const addNewKpisBlock = () => {
    setKpisBlock([...kpisBlock, kpisBlockTemplate]);
  };

  //function for delete action link block
  const onDeleteKpisBlock = (index) => {
    const filteredKpisBlock = [...kpisBlock];
    filteredKpisBlock.splice(index, 1);
    setKpisBlock(filteredKpisBlock);
    setErrors((prev) => ({ ...prev, kpis: "" }));
  };

  //select skillpoint
  const selectKpisSkills = (index, field, field2, value) => {
    const updatedFormValues = kpisBlock.map((block, i) =>
      index === i
        ? value
          ? Object.assign(block, { [field]: value, [field2]: value.value })
          : Object.assign(block, { [field]: null, [field2]: null })
        : block
    );
    setKpisBlock(updatedFormValues);
    setErrors((prev) => ({ ...prev, kpis: "" }));
  };

  //change points
  const changeSkillPointInputs = (index, field, value) => {
    const updatedFormValues = kpisBlock.map((block, i) =>
      index == i ? Object.assign(block, { [field]: value }) : block
    );

    setKpisBlock(updatedFormValues);
    setErrors((prev) => ({ ...prev, kpis: "" }));
  };

  //update kpis block from details
  const updatedKpisBlock = (kpisBlockArray) => {
    setKpisBlock(
      kpisBlockArray.map((kpis) => ({
        _id: kpis?._id || null,
        skillValue: kpis?.skillpointvalue,
        selectedSkill: kpis?.skillpointvalue?.value,
        point: kpis?.points,
      }))
    );
  };

  //validation
  const validate = () => {
    const newErrors = {};
    let isValid = true;

    if (title.trim() === "") {
      newErrors.title = t("Please enter a name for this hiring process.");
      isValid = false;
    }

    if (location.trim() === "") {
      newErrors.location = t("Please specify the location for this process.");
      isValid = false;
    }

    if (startDate === "" || endDate === "") {
      newErrors.dates = t("Please select both a start and end date.");
      isValid = false;
    } else if (new Date(startDate) > new Date(endDate)) {
      newErrors.dates = t("The end date cannot be before the start date.");
      isValid = false;
    }

    if (kpisBlock.length > 0) {
      for (const block of kpisBlock) {
        if (block.skillValue === null || block.point.trim() === "") {
          newErrors.kpis = t(
            "For each KPI, please select a skill and enter a point value."
          );
          isValid = false;
          break;
        }
      }
    }

    setErrors(newErrors);
    return isValid;
  };

  //get process details
  const getProcessDetails = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_JOB_PROCESS_DETAILS +
        `/${processId}?token=${token}`;

      const response = await getData(requestUrl);

      if (response.status && response.data) {
        const data = response.data;

        setTitle(data.title || "");
        setLocation(data.location || "");
        setOrder(data.order || 1);
        setStartDate(data.startdate);
        setEndDate(data.enddate);

        updatedKpisBlock(data.kpisarr);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //save process
  const saveProcessHandler = async () => {
    if (validate()) {
      setIsSaving(true);
      try {
        let processFormData = {
          challengeid: params.id,
          title,
          location,
          order: order || 1,
          startdate: startDate,
          enddate: endDate,
          kpisblock: kpisBlock || [],
        };

        let requestUrl = url.API_BASE_URL;
        let response = null;

        if (processId) {
          requestUrl +=
            url.API_UPDATE_JOB_PROCESS + `/${processId}?token=${token}`;

          response = await putData(requestUrl, processFormData);
        } else {
          requestUrl += url.API_ADD_NEW_JOB_PROCESS + `?token=${token}`;

          response = await postData(requestUrl, processFormData);
        }

        setIsSaving(false);
        resetHandler();

        if (response.status) {
          let offCanvasPopup = document.querySelector(
            "#offcanvasHiringProcess"
          );
          let offCanvas = bootstrap.Offcanvas.getInstance(offCanvasPopup);
          offCanvas.hide();
          onModalClose();
        }
      } catch (error) {
        console.log(error.message);
      }
    }
  };

  /* reset */
  const resetHandler = () => {
    setTitle("");
    setLocation("");
    setOrder(1);
    setStartDate(todayValue);
    setEndDate(todayValue);
    setKpisBlock([]);

    setErrors({});
    setProcessId(null);
  };

  useEffect(() => {
    if (processId) {
      getProcessDetails();
    }
  }, [processId]);

  useEffect(() => {
    getAllSkills();
  }, []);

  return (
    <div
      className="offcanvas md offcanvas-end bg-white border-0"
      tabIndex="-1"
      id="offcanvasHiringProcess"
      aria-labelledby="offcanvasHiringProcessLabel"
    >
      {/* -- Offcanvas Header with Title -- */}
      <div className="offcanvas-header bg-primary text-white p-4 pe-5 pb-3 border-bottom border-gray-300">
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary fs-5 icon-md">
              quiz
            </span>{" "}
          </div>
          <div>
            <h3
              className="offcanvas-title fw-bold text-white mb-0"
              id="offcanvasHiringProcessLabel"
            >
              {processId
                ? t("Edit Hiring Process")
                : t("Add New Hiring Process")}
            </h3>
            <p className="text-white fs-sm mb-0">
              {processId
                ? t("Manage existing hiring process details")
                : t("Define a new hiring process")}
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
      </div>

      {/* -- Offcanvas Body -- */}
      <div className="offcanvas-body p-4">
        <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm bg-light">
          <form
            onSubmit={(e) => e.preventDefault()}
            className="d-flex flex-column h-100"
          >
            {/* -- Form Fields Container (allows scrolling while footer stays fixed) -- */}
            <div className="flex-grow-1 fields-container">
              {/* -- Process Name -- */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="processName"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Process Name")} <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  id="processName"
                  name="title"
                  className={`form-control fs-sm shadow-none ${
                    errors.title ? "is-invalid" : "border border-gray-300"
                  }`}
                  placeholder={t("e.g., Technical Interview Round 1")}
                  value={title}
                  onChange={kpisFormInputChangeHandler}
                />
                {errors.title && (
                  <div className="invalid-feedback d-block mt-1">
                    {errors.title}
                  </div>
                )}
              </div>

              {/* -- Preferred Location -- */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="preferredLocation"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Preferred Location")}{" "}
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  id="preferredLocation"
                  name="location"
                  className={`form-control fs-sm shadow-none ${
                    errors.location ? "is-invalid" : "border border-gray-300"
                  }`}
                  placeholder={t("e.g., Remote, New York Office")}
                  value={location}
                  onChange={kpisFormInputChangeHandler}
                />
                {errors.location && (
                  <div className="invalid-feedback d-block mt-1">
                    {errors.location}
                  </div>
                )}
              </div>

              {/* -- Order & Start/End Date -- */}
              <div className="row mb-4 p-3 border rounded-8 shadow-sm bg-white mx-0">
                <div className="col-lg-6 ps-0">
                  <label
                    htmlFor="processOrder"
                    className="d-block fs-sm fw-semibold mb-2 text-dark"
                  >
                    {t("Order")}
                  </label>
                  <input
                    type="number"
                    id="processOrder"
                    name="order"
                    className="form-control fs-sm shadow-none border border-gray-300"
                    placeholder={t("e.g., 1")}
                    value={order}
                    onChange={kpisFormInputChangeHandler}
                  />
                </div>
                <div className="col-lg-6 pe-0">
                  <label
                    htmlFor="date"
                    className="d-block fs-sm fw-semibold mb-2 text-dark"
                  >
                    {t("Start & End Date")}{" "}
                    <span className="text-danger">*</span>
                  </label>
                  <div className="d-flex gap-2">
                    <input
                      type="date"
                      className={`form-control fs-sm shadow-none ${
                        errors.dates ? "is-invalid" : "border border-gray-300"
                      }`}
                      name="startdate"
                      value={startDate}
                      onChange={kpisFormInputChangeHandler}
                    />
                    <input
                      type="date"
                      className={`form-control fs-sm shadow-none ${
                        errors.dates ? "is-invalid" : "border border-gray-300"
                      }`}
                      name="enddate"
                      value={endDate}
                      onChange={kpisFormInputChangeHandler}
                    />
                  </div>
                  {errors.dates && (
                    <div className="invalid-feedback d-block mt-1">
                      {errors.dates}
                    </div>
                  )}
                </div>
              </div>

              {/* -- KPIs Section -- */}
              <div className="kpi-section my-4 p-3 border rounded-8 shadow-sm bg-white">
                <h6 className="fw-semibold mb-3 text-dark">
                  {t("Key Performance Indicators (KPIs)")}
                </h6>
                {kpisBlock.map((kpisData, index) => (
                  <div
                    className="form-group p-3 bg-gray-100 border rounded-3 mb-3"
                    key={index}
                  >
                    <div className="d-flex justify-content-end mb-3">
                      <Link
                        to="#"
                        className="btn btn-sm btn-outline-danger rounded-circle p-0 d-flex align-items-center justify-content-center"
                        style={{ width: "24px", height: "24px" }}
                        onClick={() => onDeleteKpisBlock(index)}
                      >
                        <span className="material-symbols-outlined fs-sm">
                          close
                        </span>
                      </Link>
                    </div>
                    <div className="row">
                      <div className="col-lg-6 mb-3 mb-lg-0">
                        <label
                          htmlFor={`kpiName-${index}`}
                          className="d-block fs-sm fw-semibold mb-2 text-dark"
                        >
                          {t("Select Skill")}{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <Select
                          isClearable
                          menuPlacement="top"
                          styles={customKpisSelectStyle}
                          placeholder={t("Search and select a skill")}
                          options={allSkills}
                          value={kpisData.skillValue}
                          onChange={(value) =>
                            selectKpisSkills(
                              index,
                              "skillValue",
                              "selectedSkill",
                              value
                            )
                          }
                        />
                      </div>
                      <div className="col-lg-6">
                        <label
                          htmlFor={`points-${index}`}
                          className="d-block fs-sm fw-semibold mb-2 text-dark"
                        >
                          {t("Points")} <span className="text-danger">*</span>
                        </label>
                        <input
                          type="number"
                          id={`points-${index}`}
                          className={`form-control fs-sm shadow-none ${
                            errors.kpis
                              ? "is-invalid"
                              : "border border-gray-300"
                          }`}
                          placeholder={t("e.g., 100")}
                          value={kpisData.point}
                          onChange={(e) =>
                            changeSkillPointInputs(
                              index,
                              "point",
                              e.target.value
                            )
                          }
                        />
                      </div>
                    </div>
                  </div>
                ))}
                {errors.kpis && (
                  <div className="invalid-feedback d-block mt-0 mb-2">
                    {errors.kpis}
                  </div>
                )}
                <button
                  type="button"
                  onClick={addNewKpisBlock}
                  className="btn btn-sm btn-outline-primary d-inline-flex align-items-center gap-1 mb-3"
                >
                  <span className="material-symbols-outlined fs-sm">add</span>
                  <span>{t("Add KPI")}</span>
                </button>
              </div>
            </div>

            {/* -- Form Action Footer -- */}
            <div className="action d-flex justify-content-end pt-3 border-top mt-auto">
              <button
                type="button"
                className="btn btn-primary d-flex align-items-center gap-2"
                onClick={saveProcessHandler}
                disabled={isSaving}
                style={{ cursor: isSaving ? "not-allowed" : "pointer" }}
              >
                {isSaving ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    {t("Saving...")}
                  </>
                ) : (
                  <>
                    <span className="material-symbols-outlined me-1">save</span>{" "}
                    {t("Save Process")}
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SaveHiringProcessPopup;
